export default "__VITE_ASSET__xU$irM$Y__"